import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import ReactApexChart from 'react-apexcharts';
import { merge } from 'lodash';
import { BaseOptionChart } from './';
import ChartErrorBoundary from '../ChartErrorBoundary';

// data: array of userrequest rows
export default function TargetVsCurrentScatter({ data = [] }) {
  // Build series for scatter: each point [currentSoc, targetSoc]
  const points = data
    .filter(d => typeof d.currentSoc === 'number' && typeof d.targetSoc === 'number')
    .map(d => ({ x: d.currentSoc, y: d.targetSoc }));

  const series = [{ name: 'Target vs Current', data: points }];

  const options = merge(BaseOptionChart(), {
    chart: { type: 'scatter', zoom: { enabled: true } },
    xaxis: { title: { text: 'Current SOC (%)' }, min: 0, max: 100 },
    yaxis: { title: { text: 'Target SOC (%)' }, min: 0, max: 100 },
    markers: { size: 6 }
  });

  // Ensure colors fallback
  if (!options.colors || !Array.isArray(options.colors) || options.colors.length === 0) {
    options.colors = ['#1976d2', '#43a047'];
  }

  // ApexCharts expects series[0].data; guard empty data
  const hasPoints = points && points.length > 0;
  const renderSeries = hasPoints ? series : [{ name: 'No data', data: [] }];
  // tooltip formatting
  options.tooltip = options.tooltip || {};
  options.tooltip.x = options.tooltip.x || {};
  options.tooltip.y = options.tooltip.y || {};
  options.tooltip.x.formatter = (val) => `Current: ${val}%`;
  options.tooltip.y.formatter = (val) => `Target: ${val}%`;

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography component="h3" variant="subtitle2" gutterBottom>
          Target vs Current SOC
        </Typography>
        {hasPoints ? (
          <ChartErrorBoundary>
            <ReactApexChart options={options} series={renderSeries} type="scatter" height={260} />
          </ChartErrorBoundary>
        ) : (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>No data to display</Typography>
        )}
      </CardContent>
    </Card>
  );
}
